import {DateTimeRangeConstraintDataDto, OffsetDateTimeString} from "../../../../../../common/apis/datatype/DataTypeConstraintDto";
import {ConstraintPluginProps} from "../ConstraintDataPlugin";
import {Grid} from "@mui/material";
import {t} from "../../../../../../store/localization/TranslMessasge";
import {DataTypeTranslationKey} from "../../DataTypeTranslationKey";
import React from "react";
import {TimeFormatsConverter} from "./TimeFormatsConverter";
import {DateTimePicker} from "../../../../../../components/fields/time/DateTimePicker";


export function DateTimeRangeConstraintPluginForm(props: Readonly<ConstraintPluginProps<DateTimeRangeConstraintDataDto>>) {
    const {data, onChange, errors} = props;

    function updateDateTimeFrom(value: OffsetDateTimeString | null | undefined) {
        let dateTimeStringToOffsetDateTimeString = TimeFormatsConverter.dateTimeStringToOffsetDateTimeString(value);
        onChange({
            ...data,
            dateTimeFrom: dateTimeStringToOffsetDateTimeString
        });
    }

    function updateDateTimeTo(value: OffsetDateTimeString | null | undefined) {
        onChange({
            ...data,
            dateTimeTo: value
        });
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <DateTimePicker
                        label={t(DataTypeTranslationKey.DATE_TIME_FROM)}
                        value={data.dateTimeFrom}
                        onChange={updateDateTimeFrom}
                        error={errors?.dateTimeFrom}/>
            </Grid>
            <Grid item xs={6}>
                <DateTimePicker
                        label={t(DataTypeTranslationKey.DATE_TIME_TO)}
                        value={TimeFormatsConverter.dateTimeStringToOffsetDateTimeString(data.dateTimeTo)}
                        onChange={updateDateTimeTo}
                        error={errors?.dateTimeTo}/>
            </Grid>
        </Grid>
    );
}
